<template>
  <div>
    <template v-for="(field, index) in fields">
      <!--Standard Inputs-->
      <template v-if="!field.type || ['text', 'email', 'password', 'textarea'].includes(field.type)">
        <b-field :label="field.label" :key="index">
          <b-input
            :type="field.type"
            :placeholder="field.placeholder"
            :required="field.required"
            :size="field.size"
            :expanded="field.expanded"
            :maxlength="field.maxlength"
            :icon="field.icon"
            icon-pack="fa"
            v-model.trim="localData[field.name]"
            @input="handleInput"></b-input>
        </b-field>
      </template>
      <!--Number Input-->
      <template v-if="field.type === 'number'">
        <b-field :label="field.label" :key="index">
          <b-input
            type="number"
            :placeholder="field.placeholder"
            :required="field.required"
            :size="field.size"
            :expanded="field.expanded"
            :maxlength="field.maxlength"
            :icon="field.icon"
            icon-pack="fa"
            v-model.number="localData[field.name]"
            @input="handleInput"></b-input>
        </b-field>
      </template>
      <!--Tag Input-->
      <template v-if="field.type === 'taginput'">
        <b-field :label="field.label" :key="index">
          <b-taginput
            v-model="localData[field.name]"
            :allow-new="true"
            :field="field.name"
            :icon="field.icon"
            :placeholder="field.placeholder">
          </b-taginput>
        </b-field>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    fields: Array,
    data: Object
  },
  data () {
    // build the initial form data object from the fields
    let initialData = {}
    const initialDataProps = this.data || {}
    this.fields.forEach((field) => {
      initialData[field.name] = initialDataProps[field.name] === undefined ? null : initialDataProps[field.name]
      initialDataProps[field.name] = initialData[field.name] === undefined ? null : initialData[field.name]
    })
    return {
      localData: initialData
    }
  },
  watch: {
    $props: {
      handler () {
        let initialData = {}
        const initialDataProps = this.data || {}
        this.fields.forEach((field) => {
          initialData[field.name] = initialDataProps[field.name] === undefined ? null : initialDataProps[field.name]
          initialDataProps[field.name] = initialData[field.name] === undefined ? null : initialData[field.name]
        })
        this.localData = initialData
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleInput () {
      this.$emit('data', this.localData)
    }
  }
}
</script>
